import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconCancel from "@material-ui/icons/Cancel";
import React, { Component, Fragment } from "react";
import {
  Button,
  CREATE,
  crudGetMatching,
  fetchEnd,
  fetchStart,
  SaveButton,
  showNotification
} from "react-admin";
import { connect } from "react-redux";
import { change, isSubmitting, submit } from "redux-form";
import dataProvider from "../dataProvider";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

class RemoveGuestBooking extends Component {
  state = {
    error: false,
    showDialog: false,
    selectedTicket: false
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleChangeSelectedTicket = e => {
    this.setState({
      selectedTicket: e.target.value
    });
  };

  handleSaveClick = () => {
    // This is needed because our modal action buttons are oustide the form
    let bookingID = this.props.data.id;
    let selectedBookingTicketID = this.state.selectedTicket;
    const { fetchStart, fetchEnd, showNotification } = this.props;
    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();
    dataProvider(CREATE, "actions/booking/removeGuestBooking", {
      data: {
        bookingID,
        selectedBookingTicketID
      }
    })
      .then(() => {
        this.setState({ showDialog: false });
        //hacky to see the effects
        window.location.reload();
      })
      .catch(error => {
        showNotification(error.message, "error");
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        fetchEnd();
      });
  };

  render() {
    const { showDialog } = this.state;
    const { isSubmitting } = this.props;
    let tickets = [];
    if (
      this.props.data &&
      this.props.data.enabledTickets &&
      this.props.data.enabledTickets[0] &&
      this.props.data.enabledTickets[0].userInfo
    ) {
      tickets = this.props.data.enabledTickets;
    }
    return (
      <Fragment>
        <Button onClick={this.handleClick} label="Remove guest"></Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick}>
          <DialogTitle>Select the guest you want to remove</DialogTitle>
          <DialogContent>
            <div>
              <p>Select the guest you want to remove</p>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={this.state.selectedTicket}
                onChange={this.handleChangeSelectedTicket.bind(this)}
              >
                {tickets.map((ticket, index) => {
                  if (ticket) {
                    return (
                      <MenuItem
                        key={ticket._id}
                        value={ticket._id}
                      >{`${ticket.userInfo.firstname} ${ticket.userInfo.surname}`}</MenuItem>
                    );
                  } else {
                    return <div></div>;
                  }
                })}
              </Select>
            </div>
          </DialogContent>
          <DialogActions>
            <SaveButton
              label="Remove"
              saving={isSubmitting}
              handleSubmitWithRedirect={this.handleSaveClick}
            />
            <Button label="Cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("post-quick-create")(state)
});

const mapDispatchToProps = {
  change,
  crudGetMatching,
  fetchEnd,
  fetchStart,
  showNotification,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveGuestBooking);
